let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3ORPj")).then(() => parcelRequire('gDF3N'));